import React from "react"
import { attach } from "../common/componentExtensions";
import UIStore, { ScreenSize } from "../common/UIStore";

class Footer extends React.PureComponent<{ screenType: ScreenSize }>{
    render() {
        const { screenType } = this.props;
        return screenType != ScreenSize.Mobile
            ? <footer className="footer d-print-none" > © {new Date().getFullYear()} Caldaie Manager <span className="float-end">v.{require("../../package.json").version}</span></footer >
            : null;
    }
}

export default attach(Footer, UIStore, (store, props) => {
    return { screenType: store.screenType }
})
